import React, { useEffect, useState } from 'react'
import Modal from '../../Modal'
import Button from '../../FormElements/Button'

const PageLeave = (props) => {
    const { state, onChange } = props
    const [defaultMessage, setDefaultMessage] = useState('There are unsaved changes. Are you sure you want to leave this page?')
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    const closeModal = () => {
        onChange(false)
    }

    const handleDecision = (decision) => {
        onChange(decision)
    }

    useEffect(() => {
        const handleResize = () => {
          setScreenWidth(window.innerWidth);
        };
    
        window.addEventListener('resize', handleResize);
    
        // Cleanup the event listener on component unmount
        return () => {
          window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Modal.Basic open={state} onCancel={closeModal} width={screenWidth < 768 ? '100%' : '50%'}>
            <div>
                <h5 className='heading-5 font-bold text-center'>Alert</h5>
                <p className='mb-2'>{props.message ? props.message : defaultMessage}</p> 
                <div className="text-slate-300 dashed-line w-full mb-2"></div>
                <div className='flex justify-end'>
                    <Button.Basic
                        onClick={()=>handleDecision(true)}
                        disabled={false}
                        icon={null}
                        loading={false}
                        type="primary"
                        size='medium'
                        text='Yes'
                        className='btn-primary bg-primary md:w-fit sm:w-fit w-full'
                    />
                    <Button.Basic
                        onClick={()=>handleDecision(false)}
                        disabled={false}
                        icon={null}
                        loading={false}
                        type="primary"
                        size='medium'
                        text='No'
                        className='btn-primary bg-black md:ml-2 sm:ml-2 md:w-fit sm:w-fit w-full'
                    />
                </div>
            </div>
        </Modal.Basic>
    )
}

export default PageLeave